export default __webpack_public_path__ + "static/media/AanshulSadaria.3edcbce9.jpg";